import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
import { Ge as R, hi as $, bo as b, w as u, di as P, M as c } from "./abstract-base-8edf0a84-e11d45a3.js";
import { d as w } from "./unsafe-svg-8b07bc77-f986d223.js";
import { c as E } from "./table-cell-7d34e150-56a6eaa3.js";
import { i as y } from "./query-24926cff-3eb94bfb.js";
import { r as L } from "./cta-variant-35c29d93-58108aa9.js";
import { M as O } from "./scale-8b395353-27d44d00.js";
import { n as N, o as q } from "./chevron-up-152a4b8b-0b6d1955.js";
import { A as h } from "./query-assigned-ba663908-228b08f4.js";
var l = /* @__PURE__ */function (d) {
  return d.ONE = "1", d.TWO = "2", d.THREE = "3", d;
}(l || {});
var C = R(_templateObject || (_templateObject = _taggedTemplateLiteral(["@charset \"UTF-8\";:host{--override-button-space-padding-tertiary: calc(.75 * var(--beacon-unit-base));--override-button-font-size-mini: var(--beacon-caption-font-size-200);--override-button-font-line-height-mini: var(--beacon-caption-font-line-height-module-200);--override-button-color-text-tertiary-default: var(--beacon-color-cta-text-tertiary-default-on-light);--override-button-icon-space-margin: var(--beacon-unit-subatomic);--content-grid-template: \"value-prop\" \"standard\";--value-prop-margin-inline-end: 0;--action-zone-left-margin-block-start: var(--beacon-unit-atomic);--stub-content-margin-inline-start: var(--beacon-table-stub-space-margin-inline-start);--stub-content-margin-inline-end: var(--beacon-table-stub-space-margin-inline-end);color:var(--beacon-color-text-default-on-light);inline-size:inherit;word-break:initial}:host([value-prop-left]){--content-grid-template: \"value-prop standard\";--value-prop-margin-inline-end: var(--beacon-unit-subatomic)}p{margin:0}.title{display:flex;grid-area:title}.title-footnote,::slotted(sup){font:var(--beacon-system-font-weight-bold, var(--beacon-font-weight-bold)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default))}.title-text{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-bold-100) var(--beacon-font-family-default))}.category{align-items:center;display:flex;grid-area:category}.standard{display:grid;grid-template-areas:\"category\" \"title\" \"attribute\" \"status\" \"description\" \"footnote\"}.title,.category{font-weight:var(--beacon-font-weight-bold)}.content{display:grid;flex-grow:1;grid-template-areas:var(--content-grid-template)}.content .standard .title{margin-block-start:var(--beacon-unit-subatomic)}.content .standard>*,.content .standard .category+.title{margin-block-start:calc(.125 * var(--beacon-unit-base))}.content .standard .status{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-module-200) var(--beacon-font-family-default));background-color:var(--beacon-color-border-secondary);border-radius:calc(.125 * var(--beacon-unit-base));grid-area:status;inline-size:fit-content;margin-block-start:var(--beacon-unit-atomic);padding-block:calc(.125 * var(--beacon-unit-base));padding-inline:calc(.375 * var(--beacon-unit-base))}.content .standard .status+*{margin-block-start:var(--beacon-unit-atomic)}::slotted([slot=title-icon]){--title-icon-margin-block-start: var(--beacon-table-stub-title-icon-space-margin-block-start-normal);margin-block-start:var(--title-icon-margin-block-start);margin-inline-start:var(--beacon-unit-subatomic)}::slotted([slot=category-icon]){margin-block:var(--beacon-table-stub-category-icon-space-margin-block)}::slotted([slot=category-icon]),::slotted([slot=title-icon]){block-size:var(--beacon-unit-base);inline-size:var(--beacon-unit-base)}::slotted([slot=action-zone-right]){margin:var(--table-override-stub-action-zone-right-space, var(--beacon-unit-atomic))}::slotted([slot=action-zone-left]){margin-block-start:var(--action-zone-left-margin-block-start)}::slotted([slot=value-prop]){grid-area:value-prop;margin-inline-end:var(--value-prop-margin-inline-end);padding:calc(.125 * var(--beacon-unit-base))}.content-wrapper{display:flex}.stub{display:grid;margin-inline-end:var(--stub-content-margin-inline-end);margin-inline-start:var(--stub-content-margin-inline-start)}.stub.level-2 .title-text,.stub.level-3 .title-text{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default))}.stub.level-2 ::slotted([slot=title-icon]),.stub.level-3 ::slotted([slot=title-icon]){--title-icon-margin-block-start: var(--beacon-table-stub-title-icon-space-margin-block-start-mini)}.stub.level-2 .content,.stub.level-3 .content{margin-inline-start:var(--table-override-stub-content-space-margin-inline-start, var(--beacon-unit-base))}.stub.level-3 .title-text{font-weight:var(--beacon-font-weight-normal)}.dropdown{display:var(--table-override-stub-dropdown-display, initial);justify-self:end}.attribute{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default));grid-area:attribute}.category-text{--category-text-margin-block-start: calc(.125 * var(--beacon-unit-base));font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-bold-200) var(--beacon-font-family-default));margin-block-start:var(--category-text-margin-block-start)}.description{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-body-100, var(--beacon-body-font-size-100)/var(--beacon-body-font-line-height-module-100) var(--beacon-font-family-default));grid-area:description;margin-block-start:var(--beacon-unit-atomic)}.footnote{font-size:var(--beacon-caption-font-size-200);grid-area:footnote;line-height:var(--beacon-caption-font-line-height-module-200)}@media (prefers-reduced-motion){.floating-stub{display:none}}@media (prefers-reduced-motion: no-preference){.floating-stub{background:var(--beacon-color-border-secondary);display:grid;grid-template-areas:\"category title\";inline-size:max-content;inset-block-start:0;inset-inline-start:var(--table-stub-floating-override-inset-inline-start, 0);margin-block-start:calc(-1 * var(--beacon-table-base-stub-space-padding-block));margin-inline-start:var(--table-stub-floating-override-margin-inline-start, -500%);padding-block-start:calc(.125 * var(--beacon-unit-base));padding-inline:var(--beacon-table-stub-floating-space-padding-inline);place-items:center;position:absolute;transform:translateY(-50%);transition:margin-inline-start 1s;z-index:2}.floating-stub .category:after{content:\"\xB7\";margin-inline:var(--beacon-table-stub-category-space-margin-inline)}.floating-stub .category-text{margin:0}.floating-stub .title,.floating-stub .category .category-text{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-200, var(--beacon-caption-font-size-200)/var(--beacon-caption-font-line-height-bold-200) var(--beacon-font-family-default))}.floating-stub .category-icon{margin-block:var(--beacon-table-stub-category-icon-space-margin-block)}}.wrapper{position:relative}@media (min-width: 1280px){.category-text{--category-text-margin-block-start: 0}}\n"])));
var D = Object.defineProperty,
  A = Object.getOwnPropertyDescriptor,
  i = function i(d, t, e, n) {
    for (var o = n > 1 ? void 0 : n ? A(t, e) : t, s = d.length - 1, r; s >= 0; s--) (r = d[s]) && (o = (n ? r(t, e, o) : r(o)) || o);
    return n && o && D(t, e, o), o;
  };
var g = "beacon-table-stub",
  B = ["beacon-button"],
  I = "·",
  x = "1px solid var(--beacon-color-border-secondary)",
  f = "0",
  M = "calc(var(--beacon-unit-atomic) + var(--beacon-table-row-space-padding))",
  p = "th",
  H = "tr",
  m = "border-block-end",
  Z = "beacon-table",
  T = "display",
  W = "none",
  j = "padding-block-end",
  _ = "--inset-divider-border",
  F = "--inset-divider-padding-block-start",
  U = "table-row",
  k = "--inset-divider-margin-start",
  Y = "calc(var(--beacon-unit-atomic) + var(--beacon-unit-base) + var(--beacon-table-stub-space-margin-inline-start))",
  G = "calc(var(--beacon-unit-atomic) + var(--beacon-unit-base) + var(--beacon-table-stub-space-margin-inline-start))",
  S = "--inset-divider-margin-end",
  K = "13px",
  z = "BEACON-CHECKBOX",
  V = "--action-zone-left-margin-block-start",
  X = "checkbox",
  J = 'input[type="checkbox"]',
  Q = "calc(var(--beacon-unit-atomic) + var(--beacon-table-stub-space-margin-inline-start))",
  tt = "calc(var(--beacon-unit-atomic) + var(--beacon-table-stub-space-margin-inline-end))";
var a = /*#__PURE__*/function (_$) {
  _inherits(a, _$);
  function a() {
    var _this;
    _classCallCheck(this, a);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(a).apply(this, arguments)), _this.beaconTagName = g, _this.nextStub = null, _this.attributeList = [], _this.category = "", _this.status = "", _this.description = "", _this.footnote = "", _this.level = l.ONE, _this.valuePropLeft = !1, _this.withDropdown = !1, _this.highlighted = !1, _this.showDropdown = !1;
    return _this;
  }
  _createClass(a, [{
    key: "renderAttributes",
    /**
     * renderAttributes
     *
     * @return {string} A string of attribute(s) that are seperated by INTERPUNCTS
     */
    value: function renderAttributes() {
      if (!this.attributeList.length) return "";
      var t = "";
      for (var e = 0; e < this.attributeList.length - 1; e += 1) t += "".concat(this.attributeList[e], " ").concat(I, " ");
      return t += this.attributeList[this.attributeList.length - 1], t;
    }
    /**
     * Used when the current instance is a level 2 stub
     * Triggers the visibility of possible level 3 children
     * @param {boolean} show - Boolean parameter that shows children on true
     */
  }, {
    key: "triggerChildren",
    value: function triggerChildren(t) {
      var e, n, o, s;
      var r = this.next;
      if (t) {
        for (; r;) r == null || r.showRow(), r = r.next;
        (n = (e = this.parentTableRow) == null ? void 0 : e.querySelector(p)) == null || n.style.setProperty(m, f);
      } else {
        for (; r;) r == null || r.hideRow(), r = r.next;
        (s = (o = this.parentTableRow) == null ? void 0 : o.querySelector(p)) == null || s.style.setProperty(m, x);
      }
    }
    /**
     * Used to trigger the state of the dropdown and visibility of level 3 children in a level 2 stub instance
     */
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.showDropdown = !this.showDropdown, this.triggerChildren(this.showDropdown);
    }
    /**
     * Use to receive a reference to the next table stub in multi-level context
     *
     * @return {BeaconTableStub} contains a level 2 or level 3 stub
     */
  }, {
    key: "setParentTableRow",
    /**
     * sets the parentTableRow class variable
     * Searches up the DOM tree to look for the first instance of a table `<tr>` element
     */
    value: function setParentTableRow() {
      var t = this.closest(H);
      t && (this.parentTableRow = t);
    }
    /**
     * sets the nextStub class variable
     * Searches for the current stub sibling to maintain a linked-list between level 2 and level 3 stubs
     */
  }, {
    key: "setNextStub",
    value: function setNextStub() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var e, n;
      if (t) {
        this.nextStub = t;
        return;
      }
      var o = (n = (e = this.parentTableRow) == null ? void 0 : e.nextElementSibling) == null ? void 0 : n.querySelector(g);
      this.level !== l.ONE && (this.level === l.TWO && (o == null ? void 0 : o.level) !== l.THREE || this.level === l.THREE && (o == null ? void 0 : o.level) !== l.THREE || (this.nextStub = o));
    }
    /**
     * Hides parent table row by setting display to none
     */
  }, {
    key: "hideRow",
    value: function hideRow() {
      var t;
      (t = this.parentTableRow) == null || t.style.setProperty(T, W);
    }
    /**
     * Shows parent table row by setting display to default table-row
     */
  }, {
    key: "showRow",
    value: function showRow() {
      var t;
      (t = this.parentTableRow) == null || t.style.setProperty(T, U);
    }
    /**
     * Sets the hasMultiLevel property of parent beacon-table component to trigger vertical divider styles
     * in multi-level stub context
     */
  }, {
    key: "setMultiLevelTableProp",
    value: function setMultiLevelTableProp() {
      var t = this.closest(Z);
      t && t.triggerMultiLevel();
    }
    /**
     * addInsetRowBorders() removes the default full width borders of table header elements and instead adds
     * inset borders in multi-level stub context
     */
  }, {
    key: "addInsetRowBorders",
    value: function addInsetRowBorders() {
      var t;
      var e = (t = this.parentTableRow) == null ? void 0 : t.querySelector(p);
      e && (e.style.setProperty(m, f), e.style.setProperty(j, f), e.style.setProperty(_, x), e.style.setProperty(F, M));
    }
    /**
     * Clones passed in childEl and inserts it before the first child of parentEl
     * @param  {HTMLElement} parentEl: Element that will hold childEl
     * @param  {Array<HTMLElement>} childEl: Element to be cloned and prepended to parentEl
     * @returns void
     */
  }, {
    key: "cloneAndPrepend",
    value: function cloneAndPrepend(t, e) {
      if (t && e != null && e.length) {
        var n = e.find(function (o) {
          return o;
        });
        if (n) {
          var o = n.cloneNode(!0);
          t.prepend(o);
        }
      }
    }
    /**
     * change action-zone-left slot padding if it contains a checkbox
     */
  }, {
    key: "handleActionZone",
    value: function handleActionZone() {
      if (this.actionZoneLeft && this.actionZoneLeft.length) {
        this.emitRenderActionZone();
        var t = this.actionZoneLeft.find(function (o) {
            return o;
          }),
          e = (t == null ? void 0 : t.getAttribute("type")) === X || (t == null ? void 0 : t.tagName) === z,
          n = (t == null ? void 0 : t.querySelector(J)) || (t == null ? void 0 : t.querySelector(z));
        (e || n) && this.style.setProperty(V, K);
      }
    }
    /**
     * Sets stub styles based on level and trailing nextStubs
     */
  }, {
    key: "setStubStyles",
    value: function setStubStyles() {
      var t;
      var e = (t = this.parentTableRow) == null ? void 0 : t.querySelector(p);
      e && (this == null ? void 0 : this.level) === l.TWO && this != null && this.showDropdown && (e == null || e.style.setProperty(m, f)), this.level === l.TWO && this.setLevelOneInsetBorder();
    }
    /**
     * Sets inset borders for sibling level 1 stub if current instance is a level 2 stub
     */
  }, {
    key: "setLevelOneInsetBorder",
    value: function setLevelOneInsetBorder() {
      var t, e, n, o, s, r;
      var v = (e = (t = this.parentTableRow) == null ? void 0 : t.previousElementSibling) == null ? void 0 : e.querySelector(g);
      v == null || v.addInsetRowBorders(), (o = (n = v == null ? void 0 : v.parentTableRow) == null ? void 0 : n.querySelector(p)) == null || o.style.setProperty(k, Q), (r = (s = v == null ? void 0 : v.parentTableRow) == null ? void 0 : s.querySelector(p)) == null || r.style.setProperty(S, tt);
    }
    /**
     * Styles set when current instance is a level 3 stub
     */
  }, {
    key: "levelThreeStubStyles",
    value: function levelThreeStubStyles() {
      var t, e, n, o, s;
      this.nextStub && ((t = this.nextStub) == null ? void 0 : t.level) === (this == null ? void 0 : this.level) && this.addInsetRowBorders(), (n = (e = this.parentTableRow) == null ? void 0 : e.querySelector(p)) == null || n.style.setProperty(k, Y), (s = (o = this.parentTableRow) == null ? void 0 : o.querySelector(p)) == null || s.style.setProperty(S, G);
    }
    /**
     * Sets the previous stub's next if a new row is inserted into the table
     */
  }, {
    key: "updatePreviousNext",
    value: function updatePreviousNext() {
      var t, e;
      var n = (e = (t = this.parentTableRow) == null ? void 0 : t.previousElementSibling) == null ? void 0 : e.querySelector(g);
      n && n.setNextStub();
    }
    /**
     * Used to re-chain the linked list if a level 3 stub is being deleted from the DOM
     */
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var t, e;
      if (this.level === l.THREE) {
        var n = (e = (t = this.parentTableRow) == null ? void 0 : t.previousElementSibling) == null ? void 0 : e.querySelector(g);
        n && n.setNextStub(this.nextStub);
      }
      _get(_getPrototypeOf(a.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      var t;
      this.setParentTableRow(), this.setStubStyles(), (t = this.handleDefer()) == null || t.then(function () {
        _get(_getPrototypeOf(a.prototype), "connectedCallback", _this2).call(_this2);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var t;
      return b(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      <div class=\"wrapper\">\n        <div class=\"floating-stub\">\n          ", "\n          <div class=\"title\"></div>\n        </div>\n        <div class=\"stub level-", "\">\n          <div class=\"content-wrapper\">\n            <slot name=\"action-zone-left\" @slotchange=\"", "\"></slot>\n            <div class=\"content has-cell-padding\" part=\"content\">\n              <slot name=\"value-prop\"></slot>\n              <div class=\"standard\">\n                ", "\n                <div class=\"title\">\n                  <slot class=\"title-text\" name=\"title\"></slot>\n                  <slot class=\"title-footnote\" name=\"title-footnote\"></slot>\n                  <slot name=\"title-icon\"></slot>\n                </div>\n                ", "\n                ", "\n                ", "\n                ", "\n              </div>\n            </div>\n            <slot name=\"action-zone-right\"></slot>\n          </div>\n          ", "\n        </div>\n      </div>\n    "])), this.category ? b(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([" <div class=\"category\">\n                <span class=\"category-icon\"></span>\n                <p class=\"category-text\">", "</p>\n              </div>"])), this.category) : u, this.level, this.handleActionZone, this.category ? b(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([" <div class=\"category\">\n                      <slot name=\"category-icon\"></slot>\n                      <p class=\"category-text\">", "</p>\n                    </div>"])), this.category) : u, (t = this.attributeList) != null && t.length ? b(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<p class=\"attribute\">", "</p>"])), this.renderAttributes()) : u, this.status ? b(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<p class=\"status\">", "</p>"])), this.status) : u, this.description ? b(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["<p class=\"description\">", "</p>"])), this.description) : u, this.footnote ? b(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["<p class=\"footnote\">", "</p>"])), this.footnote) : u, this.withDropdown ? b(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), P(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["<", "\n          class=\"dropdown\"\n          @beacon-event-click=\"", "\"\n          variant=", "\n          scale=\"", "\"\n          label=", "\n          icon-align=\"right\">", "</", ">"])), this.getScopedTag("beacon-button"), this.handleClick, L.TERTIARY, O.MINI, this.showDropdown ? "Hide Items" : "Show Items", this.showDropdown ? b(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["<span slot=\"icon\">", "</span>"])), w(N)) : b(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["<span slot=\"icon\">", "</span>"])), w(q)), this.getScopedTag("beacon-button"))) : u);
    }
  }, {
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this3 = this;
      this.cloneAndPrepend(this.floatingTitle, this.titleText), this.cloneAndPrepend(this.floatingCategory, this.categoryIcon), (this == null ? void 0 : this.level) !== l.ONE && Promise.resolve(this.setNextStub()).then(function () {
        (_this3 == null ? void 0 : _this3.level) === l.TWO && _this3.showDropdown && _this3.triggerChildren(_this3.showDropdown);
      }), this.level === l.TWO && this.setMultiLevelTableProp(), this.level === l.THREE && (this.levelThreeStubStyles(), this.updatePreviousNext(), this.hideRow());
    }
  }, {
    key: "next",
    get: function get() {
      return this.nextStub;
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(a), "styles", this), C];
    }
  }]);
  return a;
}($(E));
a.tagName = g;
a.nestedComponents = B;
i([c({
  attribute: "attribute-list",
  type: Array,
  reflect: !0
})], a.prototype, "attributeList", 2);
i([c({
  reflect: !0
})], a.prototype, "category", 2);
i([c({
  reflect: !0
})], a.prototype, "status", 2);
i([c({
  reflect: !0
})], a.prototype, "description", 2);
i([c({
  reflect: !0
})], a.prototype, "footnote", 2);
i([c({
  reflect: !0
})], a.prototype, "level", 2);
i([c({
  attribute: "value-prop-left",
  type: Boolean,
  reflect: !0
})], a.prototype, "valuePropLeft", 2);
i([c({
  attribute: "with-dropdown",
  type: Boolean,
  reflect: !0
})], a.prototype, "withDropdown", 2);
i([c({
  type: Boolean,
  reflect: !0
})], a.prototype, "highlighted", 2);
i([c({
  attribute: "show-dropdown",
  type: Boolean,
  reflect: !0
})], a.prototype, "showDropdown", 2);
i([c({
  attribute: "sort-value",
  reflect: !0
})], a.prototype, "sortValue", 2);
i([h({
  slot: "title-footnote"
})], a.prototype, "titleFootnote", 2);
i([h({
  slot: "title-icon"
})], a.prototype, "titleIcon", 2);
i([h({
  slot: "action-zone-left"
})], a.prototype, "actionZoneLeft", 2);
i([h({
  slot: "category-icon"
})], a.prototype, "categoryIcon", 2);
i([h({
  slot: "title"
})], a.prototype, "titleText", 2);
i([y(".title-text")], a.prototype, "titleElement", 2);
i([y(".floating-stub .category .category-icon")], a.prototype, "floatingCategory", 2);
i([y(".floating-stub .title")], a.prototype, "floatingTitle", 2);
var ct = /* @__PURE__ */Object.freeze( /* @__PURE__ */Object.defineProperty({
  __proto__: null,
  BeaconTableStub: a
}, Symbol.toStringTag, {
  value: "Module"
}));
export { ct as index, a as n, l as r };